import { render, staticRenderFns } from "./AlertCreateDialog.vue?vue&type=template&id=1850ebbe&scoped=true"
import script from "./AlertCreateDialog.vue?vue&type=script&lang=ts"
export * from "./AlertCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850ebbe",
  null
  
)

export default component.exports